<template>
  <div id="bio-project-materials-modal">
    <a
      id="associate-link"
      v-if="isInBioMaterials"
      @click.stop.prevent="displayModal"
      >Associate Biological Materials to Projects</a
    >
    <VButton
      v-else
      :enable-prevent="true"
      @click="displayModal"
      class="pill-primary"
    >
      Associate Materials
    </VButton>
    <QueryModals
      :group-nid="groupNid"
      :default-project-nid="defaultProjectNid"
      :is-in-bio-materials="isInBioMaterials"
      :enable-bio-material-type-select="true"
      @associate-materials="displayAssociate"
      :show-modal="true"
    />
  </div>
</template>

<script>
import { useQueryString } from "@/composables/useQueryString";
import VButton from "../raft/VButton.vue";
import QueryModals from "./QueryModals.vue";

export default {
  name: "BioProjectMaterialsModal",
  components: {
    VButton,
    QueryModals,
  },
  data() {
    return {
      bioMaterialBundles: [],
    };
  },
  setup() {
    const { updateQueryString, params, removeQueryString } = useQueryString();
    return {
      updateQueryString,
      params,
      removeQueryString,
    };
  },
  methods: {
    displayModal() {
      this.updateQueryString("modal", "BioProjectMaterialsBModal");
    },
    closeModal() {
      this.$refs.associateMaterialsModal.hide();
      this.removeQueryString("modal");
      window.location.reload();
    },
    displaySearchAdd() {
      this.$refs.searchAdd.displayModal();
    },
    displayAssociate() {
      this.$refs.searchAdd.closeModal();
      this.$refs.associateMaterialsModal.show();
    },
  },
  props: {
    groupNid: { type: String, required: true },
    defaultProjectNid: { type: String, default: "" },
    isInBioMaterials: { type: Boolean, default: false },
  },
  computed: {
    paramString() {
      return this.params?.toString();
    },
  },
  mounted() {
    const bundles = JSON.parse(this.params.get("bundles"));
    this.bioMaterialBundles = bundles;
  },
};
</script>

<style scoped>
#associate-link {
  cursor: pointer;
}
</style>
